import classNames from 'classnames';
import { useAnchorable } from '../../hooks/useAnchorable';
import { bulletList, bulletListContainer } from './BulletList.css';
import type { PostBulletListProps } from './BulletList.types';

export const PostBulletList = ({
  element,
  children,
  className,
  // we don't want these extra props in the ...props rest since we're spreading it on a div
  isLive,
  isIndexingDisabled,
  rewriteImageSrc,
  homePath,
  loginPath,
  subscribePath,
  isSubscriberAuthenticated,
  ...props
}: PostBulletListProps) => {
  const { anchorAttributes } = useAnchorable(element.attrs);

  return (
    <div {...anchorAttributes} className={classNames(className, bulletListContainer)}>
      {/* spreading props on standard DOM elements causes React warnings and hydration errors */}
      <ul {...props} className={classNames(bulletList)}>
        {children}
      </ul>
    </div>
  );
};
